// Fee schedule and CDT list (CLAIMS_UI_BUILD_SPEC §14.1). Mock, read-only.

export interface CdtEntry {
  code: string;
  description: string;
  fee: number;
  group: string;
}

export const CDT_LIST: CdtEntry[] = [
  { code: 'D0120', description: 'Periodic oral evaluation', fee: 62, group: 'exam' },
  { code: 'D0150', description: 'Comprehensive oral evaluation', fee: 89, group: 'exam' },
  { code: 'D0210', description: 'X-rays, complete series', fee: 125, group: 'exam' },
  { code: 'D0274', description: 'Bitewings, four films', fee: 82, group: 'exam' },
  { code: 'D1110', description: 'Prophylaxis, adult', fee: 183, group: 'cleaning and exam' },
  { code: 'D1206', description: 'Fluoride varnish', fee: 56, group: 'cleaning and exam' },
  { code: 'D2391', description: 'Composite, one surface, posterior', fee: 185, group: 'filling' },
  { code: 'D2393', description: 'Composite, three surfaces, posterior', fee: 264, group: 'filling' },
  { code: 'D2740', description: 'Crown, porcelain/ceramic', fee: 1295, group: 'crown' },
  { code: 'D2750', description: 'Crown, porcelain fused to high noble metal', fee: 1150, group: 'crown' },
  { code: 'D2950', description: 'Core build-up, including any pins', fee: 285, group: 'crown' },
  { code: 'D3330', description: 'Root canal, molar', fee: 1240, group: 'root canal' },
  { code: 'D4341', description: 'Scaling and root planing, 4+ teeth per quadrant', fee: 265, group: 'periodontal' },
  { code: 'D6010', description: 'Implant body, endosteal', fee: 2140, group: 'implant' },
  { code: 'D7140', description: 'Extraction, erupted tooth', fee: 240, group: 'extraction' },
];

export const CDT_BY_CODE: Record<string, CdtEntry> = Object.fromEntries(
  CDT_LIST.map((e) => [e.code, e]),
);

export const CODE_GROUP: Record<string, string> = Object.fromEntries(
  CDT_LIST.map((e) => [e.code, e.group]),
);
